import React from 'react';
import Icon from '../Icon';
import svg from '../icons/status-confirmation-onlight.js';

const IconStatusConfirmationOnlight = (props) => <Icon {...props} svg={svg} />;

IconStatusConfirmationOnlight.displayName = 'IconStatusConfirmationOnlight';

export default IconStatusConfirmationOnlight;
